// extracted by mini-css-extract-plugin
export default {"payoutText":"PayoutText_payoutText__F9-Wu","main":"PayoutText_main__rLytw","sum":"PayoutText_sum__2zRtQ","date":"PayoutText_date__2OJnh"};